export default __webpack_public_path__ + "static/media/Annons 4.5d1d20ff.jpg";